const topics = [
  { tag: '最新电影', hot: '9.8w', icon: 'ri-movie-line', color: 'primary' },
  { tag: '热门剧集', hot: '8.5w', icon: 'ri-tv-line', color: 'accent' },
  { tag: '综艺推荐', hot: '7.2w', icon: 'ri-emotion-happy-line', color: 'primary' },
  { tag: '动漫连载', hot: '6.8w', icon: 'ri-ghost-smile-line', color: 'secondary' },
  { tag: '经典回顾', hot: '5.4w', icon: 'ri-history-line', color: 'accent' },
  { tag: '高评分推荐', hot: '9.1w', icon: 'ri-star-line', color: 'primary' },
  { tag: '本周热播', hot: '10w+', icon: 'ri-fire-line', color: 'accent' },
  { tag: '新片速递', hot: '8.9w', icon: 'ri-rocket-line', color: 'secondary' },
  { tag: '影评讨论', hot: '4.7w', icon: 'ri-chat-3-line', color: 'primary' },
];

const colorStyles: Record<string, { bg: string; text: string; border: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', border: 'border-primary-200', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', border: 'border-accent-200', iconBg: 'bg-accent-100' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', border: 'border-secondary-200', iconBg: 'bg-secondary-100' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            探索当前最受关注的影视话题，香蕉视频、红桃视频、91视频、蜜桃视频最新热播内容一网打尽
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {topics.map((topic, idx) => {
            const s = colorStyles[topic.color];
            return (
              <a
                key={idx}
                href="#topics"
                onClick={(e) => e.preventDefault()}
                className={`group flex flex-col items-center gap-3 p-5 rounded-2xl ${s.bg} border ${s.border} hover:scale-[1.02] transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-12 h-12 rounded-xl ${s.iconBg} flex items-center justify-center`}>
                  <i className={`${topic.icon} ${s.text} text-xl`}></i>
                </div>
                <span className={`text-sm font-semibold ${s.text} whitespace-nowrap`}>#{topic.tag}</span>
                <span className="text-xs text-foreground-500">热度 {topic.hot}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}